import { createContext } from 'react';

import type { ActiveLocale } from '@dnc/baseline/utils/localization';

export const LocaleContext = createContext('es' as ActiveLocale);
